export type LinearRegressionDataPoint = {
  x: number;
  y: number;
};

export function linearRegression(data: LinearRegressionDataPoint[]) {
  let xsum = 0;
  let ysum = 0;
  for (let i = 0; i < data.length; i++) {
    xsum += data[i].x;
    ysum += data[i].y;
  }
  const xmean = xsum / data.length;
  const ymean = ysum / data.length;

  let num = 0;
  let denom = 0;
  for (let i = 0; i < data.length; i++) {
    const x = data[i].x;
    const y = data[i].y;
    num += (x - xmean) * (y - ymean);
    denom += (x - xmean) * (x - xmean);
  }

  const m = denom === 0 ? 0 : num / denom;
  const b = ymean - m * xmean;

  return { m, b };
}
